<script lang="ts">
  import Default from './Default.svelte';

  export let label = '';
  export let caption = '';
  export let placeholder = 'Select an item';
  export let danger: boolean = false;
  export let dangerMessage: string = '';
  export let value = '';
  export let options: string[] = [];
  export let selectedValues: string[] = [];
  export let inputFocused: boolean = false;
  export let dropdownOpen: boolean = false;
</script>

<Default
  multiple={true}
  bind:options
  bind:label
  bind:caption
  bind:placeholder
  bind:danger
  bind:dangerMessage
  bind:dropdownOpen
  bind:inputFocused
  bind:value
  bind:selectedValues
  on:change
  notReadOnly
  class={$$props.class}
/>
